// This function updates the price and discount
function updatePriceAndDiscount(variant) {
  var selectedVariantPrice = variantPrices[variant];
  if (selectedVariantPrice) {
    var discountRate;
    if (document.querySelector('.promotion-block.special-discount')) {
      discountRate = 0.20;
    } else if (document.querySelector('.promotion-block.standard-discount')) {
      discountRate = 0.15;
    }

    if (discountRate) {
      var discount_value = selectedVariantPrice * discountRate;
      var sales_price = selectedVariantPrice - discount_value;
      var savingsEl = document.querySelector('.savings');
      if (savingsEl) savingsEl.textContent = "£" + discount_value.toFixed(2);
      var discountedPriceEl = document.querySelector('.discounted-price');
      if (discountedPriceEl) discountedPriceEl.textContent = "Discounted Price: £" + sales_price.toFixed(2);
      var voucherPriceEl = document.querySelector('[data-voucher-price]');
      var voucherSavingEl = document.querySelector('[data-voucher-saving]');
      if (voucherPriceEl) voucherPriceEl.textContent = "£" + sales_price.toFixed(2);
      if (voucherSavingEl) voucherSavingEl.textContent = "£" + discount_value.toFixed(2);
    }
  }
}

// Event listener setup for radio buttons
var radios = document.querySelectorAll('.options-selection__option-value-input');
radios.forEach(function(radio) {
  radio.addEventListener('change', function() {
    var selectedOptions = document.querySelectorAll('.options-selection__option-value-input:checked');
    var variant = Array.from(selectedOptions).map(option => option.value).join(' / ');
    updatePriceAndDiscount(variant);
  });
});

document.addEventListener('variant-change', function(e) {
  if (e.detail && e.detail.variant && e.detail.variant.title) {
    updatePriceAndDiscount(e.detail.variant.title);
  }
}, true);

var voucher = document.querySelector('[data-voucher]');
if (voucher) {
  var voucherCheck = voucher.querySelector('[data-voucher-check]');
  if (voucherCheck) {
    voucherCheck.addEventListener('change', function() {
      if (voucherCheck.checked) {
        var code = voucher.getAttribute('data-voucher-code');
        if (code) {
          fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function() {});
        }
      }
    });
  }
}

// Initial update for the currently selected variant
var currentVariant = Array.from(document.querySelectorAll('.options-selection__option-value-input:checked')).map(option => option.value).join(' / ');
updatePriceAndDiscount(currentVariant);